import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    const slider = this.el.querySelector('[data-slider]')
    const prevEl = this.el.querySelector('[data-slider-prev]')
    const nextEl = this.el.querySelector('[data-slider-next]')

    new Swiper(slider, {
      modules: [Navigation],
      navigation: {
        nextEl,
        prevEl,
      },
      autoHeight: true,
      slidesPerView: 1,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          autoHeight: false,
        },
        1024: {
          slidesPerView: 4,
          autoHeight: false,
        },
        1280: {
          slidesPerView: 7,
          autoHeight: false,
        },
      },
    })
  }
}
